
<template lang="pug">
div
  app-side-nav
  router-view
</template>
<script>
import AppSideNav from '@/components/app-side-nav'

export default {
  meta: {
    title: 'Supplier',
    titleTemplate: '%s - Inom.ph'
  },
  components: {
    AppSideNav
  }
}
</script>

<style>
@media only screen and (min-width: 992px) {
  .v-dialog {
    margin-left: 324px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/template-dashboard.vue